<template>
  <div class="d-flex flex-column">
    <SidebarItem
      class="order-md-0 order-3"
      text="Minha jornada"
      to="/aluno"
    >
      <template #icon>
        <use xlink:href="#icon-navigation" />
      </template>
    </SidebarItem>

    <SidebarItem
      class="order-md-2 order-1"
      text="Calendário"
      to="/aluno/calendario"
    >
      <template #icon>
        <use xlink:href="#icon-calendar" />
      </template>
    </SidebarItem>
    <SidebarItem
      class="order-md-2 order-1"
      text="Estude agora"
      :to="redirectRouteName"
    >
      <template #icon>
        <use xlink:href="#icon-book-sidebar" />
      </template>
    </SidebarItem>
    <SidebarItem
      class="order-md-3 order-0"
      text="Relatórios"
      :to="{name:'student.metric.index'}"
    >
      <template #icon>
        <use xlink:href="#icon-paper" />
      </template>
    </SidebarItem>
  </div>
</template>
<script>

import SidebarItem from "@/common/components/sidebar/SidebarItem.vue";
import { selectModulesRouteName, studyNowRouteName } from '@/student/constants/routes';
import { mapGetters } from "vuex";

export default {
  components:{
    SidebarItem,
  },
  computed: {
    ...mapGetters([
      'currentCycleHasModules',
      'currentCycleIsFinished',
    ]),
    redirectRouteName() {
      return this.currentCycleHasModules || this.currentCycleIsFinished ? { name: studyNowRouteName } : { name: selectModulesRouteName };
    },
  },
  }
</script>
